import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { SlideLessonPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.slide.index._context";
import { useSlideLessonContinueMutation } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.slide.index._lib.continue";
import { useCallback } from "react";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActivityIndicator, Pressable, View } from "@-/com.npmjs.react-native";

// Match the welcome CTA's compact pill, while letting descriptive labels such as
// "Continue with Simplified" grow beyond one-third width instead of becoming a tall button.
const CONTINUE_PILL_CLASS_NAME =
  "relative max-w-full min-w-1/3 flex-row items-center justify-center gap-2 rounded-full border border-black/15 bg-white px-6 py-2.5";

export function SlideLessonContinueButton() {
  const [nextButtonLabel] = useContextSelectors(SlideLessonPageContext, (c) => c.nextButtonLabel);
  const continueMutation = useSlideLessonContinueMutation();
  const handlePress = useCallback(() => {
    continueMutation.mutate();
  }, [continueMutation]);

  return (
    <Pressable
      accessibilityLabel={continueMutation.isPending ? "Loading next…" : nextButtonLabel}
      accessibilityRole="button"
      accessibilityState={{
        busy: continueMutation.isPending,
        disabled: continueMutation.isPending,
      }}
      accessible
      className={`${CONTINUE_PILL_CLASS_NAME} active:bg-gray-100`}
      disabled={continueMutation.isPending}
      nativeID="slide-lesson-continue-button"
      onPress={handlePress}
      testID="slide-lesson-continue-button"
    >
      <Text className={`text-black ${continueMutation.isPending ? "opacity-25" : ""}`}>
        {nextButtonLabel}
      </Text>
      {continueMutation.isPending ? (
        <View className="absolute inset-0 items-center justify-center" pointerEvents="none">
          <ActivityIndicator color="#171717" size="small" />
        </View>
      ) : null}
    </Pressable>
  );
}
